import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    selector: 'app-insure-buy',
    templateUrl: './insure-buy.component.html',
    styleUrls: ['./insure-buy.component.css'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class InsureBuyComponent {

}
